// extracted by mini-css-extract-plugin
export default {"container":"Serving_Links_container__eHyRN","heading":"Serving_Links_heading__4694J","inner":"Serving_Links_inner__mh4Cq","list":"Serving_Links_list__TCOmU"};